import Icon from '@/components/shared/icons'
import { Box, Button, Image } from '@chakra-ui/react'

const ImageItem = ({
	id,
	preview,
	name,
	removeFile,
}: {
	id: string
	preview: string
	name: string
	removeFile: (id: string) => void  
}) => {
	return (
		<Box
			position='relative'
			w='100%'
			h='12vh'
			overflow='hidden'
			borderRadius='md'
		>
			<Image
				src={preview}
				alt={name}
				w='100%'
				h='100%'
				objectFit='cover'
				objectPosition='center'
			/>
			<Button
				border='none'
				bg='white'
				p='0.5'
				position='absolute'
				borderRadius='full'
				boxShadow='md'
				top='1'
				right='1'
				onClick={() => removeFile(id)}
			>
				<Icon icon='delete' size='xl' color='black' />
			</Button>
		</Box>
	)
}

export default ImageItem
